export class SellingPointModel {
    code?: string;
    name?: string;
    sellingPointParentCode?: string;
    active?: boolean;
    details?: Details[];
  }
  
  export class Details {
    bankInfos?: BankingInfo;
    clientNumber?: string;
  }
  
  export class BankingInfo {
    companyName?: string;
    bic?: string;
    iban?: string;
  }